<template>
  <div class="body">
    <div class="heroSection">
      <Header headerColor="white" />
      <div>
        <Title />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../SharedComponents/Header.vue";
import Title from "./HeroSection/Title.vue";

export default {
  name: "HeroSection",
  components: {
    Header,
    Title,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body {
  width: 100%;
  height: 100vh;
  background-image: url("../../assets/background.jpeg");
  background-position: 0 20%;
  background-repeat: no-repeat;
  background-size: cover;
}
.heroSection {
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

@media (max-width: 588px) {
}
</style>
